module.exports = __webpack_public_path__ + "img/pen1.ba963c66.png";